module.exports = __webpack_public_path__ + "img/sub3.628a9add.jpg";